
export const modifySchema = (result, status) => ({
    data : result,
    status : status
})
